import "./App.scss";
import { runApp } from "@eusoft/webapp-framework";
import { VcApp } from "./VcApp";

runApp(new VcApp());
